import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import directDebitFuncs, { DirectDebit } from '../model/directDebit';
import creditTransferFuncs, { CreditTransfer } from '../model/creditTransfer';

export interface BackendDirectDebit {
  createPreview(formData: FormData, lang?: string): AxiosPromise<DirectDebit>;
  createPreviewForTrainers(
    formData: FormData,
    lang?: string
  ): AxiosPromise<CreditTransfer>;
  createSEPAFiles(
    directDebitData: DirectDebit,
    lang?: string
  ): AxiosPromise<any>;
  createSEPAFilesForTrainers(
    creditTransferData: CreditTransfer,
    lang?: string
  ): AxiosPromise<any>;
}

export const defaultBackendDirectDebit: BackendDirectDebit = {
  createPreview(formData: FormData, lang?: string): AxiosPromise<DirectDebit> {
    const url = `${URLS.directDebit}/Preview`;
    return instance.post<DirectDebit>(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: (data) => data,
      params: lang ? { lang: lang } : undefined,
    });
  },
  createPreviewForTrainers(
    formData: FormData,
    lang?: string
  ): AxiosPromise<CreditTransfer> {
    const url = `${URLS.directDebit}/PreviewForTrainers`;
    return instance.post<CreditTransfer>(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: (data) => data,
      params: lang ? { lang: lang } : undefined,
    });
  },
  createSEPAFiles(
    directDebitData: DirectDebit,
    lang?: string
  ): AxiosPromise<any> {
    const url = `${URLS.directDebit}/CreateSEPAFiles`;
    return instance.post<any>(url, directDebitFuncs.toAPI(directDebitData), {
      responseType: 'blob',
      params: lang ? { lang: lang } : undefined,
    });
  },
  createSEPAFilesForTrainers(
    creditTransferData: CreditTransfer,
    lang?: string
  ): AxiosPromise<any> {
    const url = `${URLS.directDebit}/CreateSEPAFilesForTrainers`;
    return instance.post<any>(
      url,
      creditTransferFuncs.toAPI(creditTransferData),
      {
        responseType: 'blob',
        params: lang ? { lang: lang } : undefined,
      }
    );
  },
};
